import type { Router } from 'vue-router'

/**
 * If the user came from another in-app route, goes back; otherwise runs {@link fallback}
 * (e.g. condition status when the report was opened in a new tab or as the first history entry).
 */
export const goBackInAppOr = (router: Router, fallback: () => void) => {
    if (typeof window !== 'undefined' && window.history.state != null && window.history.state.back != null) {
        router.back()
        return
    }
    fallback()
}
